import React from 'react';
import { createPortal } from 'react-dom';
import { CheckCircle2, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import {
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalTitle,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  ModalSubmitButton,
} from '../../Navbar/modals/changePasswordModal.styles';

const UploadSuccessModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleGoToDashboard = () => {
    onClose();
    navigate('/');
  };

  return createPortal(
    <ModalOverlay
      onClick={onClose}
      tabIndex={-1}
      role="dialog"
      aria-modal="true"
      aria-labelledby="upload-success-title"
    >
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <ModalHeader>
          <ModalTitle id="upload-success-title">Success</ModalTitle>
          <ModalCloseButton onClick={onClose} type="button" aria-label="Close">
            <X size={16} />
          </ModalCloseButton>
        </ModalHeader>

        <ModalBody>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <CheckCircle2 size={20} style={{ color: '#2f9e5b', flexShrink: 0 }} />
            <span>Your documents have been saved successfully.</span>
          </div>
        </ModalBody>

        <ModalFooter>
          <ModalSubmitButton type="button" onClick={handleGoToDashboard}>
            Go to Dashboard
          </ModalSubmitButton>
        </ModalFooter>
      </ModalContent>
    </ModalOverlay>,
    document.body
  );
};

export default UploadSuccessModal;
